import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgUserFile = (props) => (
  <SvgIcon {...props} title="UserFile">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#User-File_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.528.098c-.69.238-1.2.752-1.433 1.444-.145.432-.147 3.88-.002 4.118.282.463 1.031.463 1.313 0 .089-.144.094-.239.094-1.77 0-1.767.016-1.9.253-2.137.258-.258.147-.253 5.384-.253H15v2.837c0 3.365.01 3.426.686 4.06.644.605.633.603 3.977.603H22.5v6.363c0 6.843.008 6.623-.253 6.884-.246.246-.32.252-2.888.253-2.647 0-2.552-.011-2.766.34-.207.34-.086.864.246 1.066.242.148 5.184.145 5.622-.002a2.253 2.253 0 0 0 1.444-1.448c.096-.284.096-.33.084-7.61l-.012-7.323-.179-.375C23.52 6.561 17.44.48 16.852.201l-.375-.178-5.836-.01C4.878.003 4.8.003 4.528.098Zm15.178 7.39c-3.541.018-3.205.354-3.206-3.199V1.852l2.813 2.812 2.812 2.812-2.42.013ZM7.289 7.53c-5.594.824-8.796 6.342-6.65 11.46 2.222 5.303 9.179 6.718 13.347 2.715 3.66-3.515 3.28-9.578-.79-12.588-1.006-.744-2.08-1.22-3.346-1.483-.438-.09-2.171-.161-2.561-.104Zm2.106 1.593c5.003.848 7.265 6.796 4.113 10.815l-.214.273-.166-.203c-.868-1.062-2.663-2.195-3.479-2.195-.05 0 .104-.1.344-.221 2.601-1.321 2.679-5.206.132-6.616a3.907 3.907 0 0 0-3.75 0c-2.547 1.41-2.47 5.295.132 6.616.24.122.395.221.344.221-.816 0-2.611 1.133-3.48 2.195l-.165.203-.214-.273c-3.804-4.85.336-11.843 6.403-10.815Zm-.817 2.926c.69.108 1.355.603 1.666 1.24 1.085 2.223-1.805 4.274-3.556 2.524-1.374-1.375-.463-3.662 1.515-3.806.039-.003.208.016.375.042Zm.328 7.192c1.173.18 2.301.83 2.994 1.728.242.314.254.269-.146.518-1.867 1.163-4.268 1.305-6.312.374-.364-.166-1.036-.563-1.036-.613 0-.066.41-.551.666-.787 1.062-.983 2.463-1.429 3.834-1.22Z"
          fill="#017163"
        />
      </g>
      <defs>
        <clipPath id="User-File_svg__a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);

export default SvgUserFile;
